import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { PageStyle } from '../../../../assets/styles/custom.styles';
import getErrorMessage from '../../../../assets/utils/getErrorMessage';
import CustomerOverview from '../../../../components/partner/customer/customerOverview';
import { Language } from '../../../../interfaces/Language';

export interface TenantOverviewObject {
  name: string;
  slug: string;
  languages: Language[];
  paymentStatus: string;
  subscriptionStartDate: string | null;
  subscriptionNextRenewal: string | null;
  subscriptionBillingDate: string | null;
  contactPerson: string | null;
  contactEmail: string | null;
}

interface TenantOverviewFromApiObject {
  name: string;
  slug: string;
  languages: Language[];
  payment_status: string;
  subscription_start_date: string | null;
  subscription_next_renewal: string | null;
  subscription_billing_date: string | null;
  contact_person: string | null;
  contact_email: string | null;
}

const transformTenantData = (data: TenantOverviewFromApiObject[]) => {
  const tenants: TenantOverviewObject[] = data.map(({ 
    name, 
    slug, 
    languages, 
    payment_status, 
    subscription_start_date, 
    subscription_next_renewal, 
    subscription_billing_date,
    contact_person,
    contact_email,
  }) => ({
    name, 
    slug,
    languages,
    paymentStatus: payment_status,
    subscriptionStartDate: subscription_start_date, 
    subscriptionNextRenewal: subscription_next_renewal,
    subscriptionBillingDate: subscription_billing_date,
    contactPerson: contact_person,
    contactEmail: contact_email,
  }
  ));
  return tenants;
};

const CustomerOverviewPage = () => {
  
  const [customerList, setCustomerList] = useState<Array<TenantOverviewObject>>([]);

  const { data, isLoading, error } = useSWR( '/confide/tenants/overview', { revalidateOnFocus: false });

  useEffect(() => {
    if (!isLoading && !error) {
      const transformedData = transformTenantData(data);
      setCustomerList(transformedData);
    }
  }, [data, isLoading, error]);


  return (
    <Stack sx={PageStyle.container}>
      <CustomerOverview 
        isLoading={isLoading}
        isError={error}
        errorText={getErrorMessage(error)}
        list={customerList}/>
    </Stack>
  );
};

export default CustomerOverviewPage;